<template>
  <div>
    <v-dialog v-model="showDetailsDialog" persistent max-width="600px" width="600px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="showDetailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>تفاصيل المذكرة</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 20px"></div>
          <v-row>
            <v-col cols="4">الموضوع</v-col>
            <v-col cols="8">{{ document.subjectName }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4">نص الكتاب</v-col>
            <v-col cols="8">{{ document.subjectDescription }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="4">تاريخ الكتاب</v-col>
            <v-col cols="8">{{ document.archiveDateFormatted }}</v-col>
          </v-row>

          <v-row>
            <v-col cols="4">الملاحظات</v-col>
            <v-col cols="8">{{ document.note }}</v-col>
          </v-row>
        </v-card-text>

        <div style="margin: 15px">
          <v-row>
            <h3 v-if="images == null">لا توجد مرفقات</h3>
            <v-col cols="6" v-for="(image, index) in images" :key="index">
              <img v-if="!getFileInfo(image)" crossOrigin="anonymous" @click="fullScreenImage($event)" :src="`${$store.state.apiUrlArchive}/${image.imagePath}`" width="100%" />
              <vue-pdf-embed v-else :source="`${$store.state.apiUrlArchive}/${image.imagePath}`" @click="fullScreenImage($event)" />
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="showDetailsDialog = false"> موافق </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
export default {
  components: {
    VuePdfEmbed,
  },
  props: {
    images: Array,
  },
  data: () => ({
    showDetailsDialog: false,
    document: {},
  }),
  methods: {
    getFileInfo(file) {
      let isPdf = file.imagePath.includes(".pdf");
      console.log(isPdf);
      return isPdf;
    },
    fullScreenImage(e) {
      const doc = new jsPDF();

      const getBase64StringFromDataURL = (dataURL) => dataURL.replace("data:", "").replace(/^.+,/, "");

      const canvas = document.createElement("canvas");

      canvas.width = e.target.naturalWidth;
      canvas.height = e.target.naturalHeight;

      canvas.getContext("2d").drawImage(e.target, 0, 0);

      const dataURL = canvas.toDataURL();

      const base64 = getBase64StringFromDataURL(dataURL);

      doc.addImage(base64, 0, 0, 210, 300);
      doc.save("document.pdf");

      canvas.remove();

      // let imageWindow = window.open(
      //   "",
      //   "",
      //   "left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0"
      // );

      // imageWindow.document.write(`<!DOCTYPE html>
      //             <html>
      //             <head></head>
      //             <body></body> <img src="${this.$store.state.apiUrl}/${image.imagePath}"  style="margin-top: 10px;"></html>`);

      // setTimeout(() => {
      //   imageWindow.document.close();
      //   imageWindow.focus();
      //   imageWindow.print();
      //   imageWindow.close();
      // }, 500);
      // //  setTimeout(function () {
      // //  }, 500);
    },
    showDialogDetails(document) {
      this.document = document;
      this.showDetailsDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
